// extracted by mini-css-extract-plugin
export default {"headerButton":"qlbLD4aHr1aoyfqn01LU","pulsatingDot":"rYbWkU6nOqHMQws10lng","mobilePromptBox":"WqYBn0D4GmnZQHhXi7Aa","christmasPromptPillLabel":"iW30ilkW8cvqTiG9kkWg"};